export const XRomanOneSvg = ({ height }: { height: number }) => {
  return (
    <svg
      width={(height / 24) * 7}
      height={height}
      viewBox="0 0 7 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.81081 1.83333L5.2973 0H1.89189L0.378378 1.83333H2.27027V22.3333L0 24H7L4.91892 22.3333V1.83333H6.81081Z"
        fill="url(#paint0_linear_217_382)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_217_382"
          x1="7"
          y1="12"
          x2="0"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D0B3A5" stopOpacity="0.18" />
          <stop offset="0.489583" stopColor="#D0B3A5" />
          <stop offset="1" stopColor="#D0B3A5" stopOpacity="0.14" />
        </linearGradient>
      </defs>
    </svg>
  );
};
